import * as React from 'react'
import './index.scss'
import { connect } from "react-redux";
import { ActionType, accountInfoType, reducerStoreType, cashType } from "../../reducers/types";
import { Dispatch } from "redux";
import { injectIntl, IntlShape } from 'react-intl'
import Grid from "@material-ui/core/Grid";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { PrimaryButton, WhiteButton } from "../../components/CustomUIComp/CustomFormElem";
import { toast } from "react-toastify";
import { globalIntl } from "../App/App";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    lab: {
      display: 'block',
      height: '14px',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '14px',
      color: '#666'
    },
    text: {
      display: 'block',
      height: '14px',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '14px',
    },
    input: {
      display: 'block',
      border: '1px solid #ccc',
      outlineColor: 'skyblue',
      width: '150px',
      height: '22px',
      textIndent: '5px',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '22px'
    }
  }),
);

export interface SimpleDialogProps {
  open: boolean;
  onOk: () => void;
  onClose: () => void;
  onChange: (value: any) => void;
  accountInfo: accountInfoType;
  cashInfo: cashType;
  intl: IntlShape
}

function SimpleDialog(props: SimpleDialogProps) {
  const classes = useStyles();
  let { onClose, onOk, open, intl, accountInfo, onChange, cashInfo } = props;

  const handleClose = () => {
    onClose();
  };
  const check = () => {
    if (cashInfo.withdrawAmt >= accountInfo.lowestAmt && cashInfo.withdrawAmt <= accountInfo.canWithdrawAmt) {
      return true
    } else {
      return false
    }
  }
  const handleOk = () => {
    if (check()) {
      onOk();
    } else {
      toast.error(globalIntl.formatMessage({ id: 'cashToast' }))
    }
  };
  const handleChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    onChange(event.target)
  }
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="sm"
      aria-labelledby="confirmation-dialog-title"
      open={open}
    >
      <DialogTitle className={classes.text} id="confirmation-dialog-title">{intl.formatMessage({ id: 'cash' })}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <label className={classes.lab}>{intl.formatMessage({ id: 'bank' })}</label>
          </Grid>
          <Grid item xs={8}>
            <span className={classes.text}>{accountInfo.bankName}</span>
          </Grid>
          <Grid item xs={4}>
            <label className={classes.lab}>{intl.formatMessage({ id: 'accountNumber' })}</label>
          </Grid>
          <Grid item xs={8}>
            <span className={classes.text}>{accountInfo.accountNo}</span>
          </Grid>
          <Grid item xs={4}>
            <label className={classes.lab}>{intl.formatMessage({ id: 'accountName' })}</label>
          </Grid>
          <Grid item xs={8}>
            <span className={classes.text}>{accountInfo.accountName}</span>
          </Grid>
          <Grid item xs={4}>
            <label className={classes.lab}>{intl.formatMessage({ id: 'withdrawal' })}</label>
          </Grid>
          <Grid item xs={8}>
            <span className={classes.text}>{accountInfo.canWithdrawAmt}{accountInfo.orgCurrency}</span>
          </Grid>
          <Grid item xs={4}>
            <label className={classes.lab}>{intl.formatMessage({ id: 'money' })}</label>
          </Grid>
          <Grid item xs={8}>
            <input type="number" className={classes.input} value={cashInfo.withdrawAmt} onChange={handleChange} name='cash' />
          </Grid>
        </Grid>
      </DialogContent>
      <div className="cashModal">
        <div className="button-line">
          <WhiteButton onClick={handleClose}>
            {intl.formatMessage({ id: 'cancel' })}
          </WhiteButton>
          <PrimaryButton onClick={handleOk}>
            {intl.formatMessage({ id: 'confirm' })}
          </PrimaryButton>
        </div>
      </div>
    </Dialog>
  );
}

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  accountInfo: accountInfoType,
  cashInfo: cashType,
  intl: IntlShape
}

interface IState {
  open: boolean
}

class AccountInfo extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      open: false
    }
  }
  handleConfirm = () => {
    this.props.dispatch({ type: 'MONEY_GET', payload: { key: 'submit' } })
  }

  handleClickOpen = () => {
    this.setState({
      open: true
    })
  };
  handleClose = () => {
    this.setState({
      open: false
    })
  };
  handleChange = (object: { name: string, value: any }) => {
    this.props.dispatch({ type: 'MONEY_GET', payload: { object, key: 'change' } })
  }

  public render() {
    let { accountInfo, intl } = this.props
    return (
      <div className="basicInfo">
        <div className="header">
          <h2>{intl.formatMessage({ id: 'account' })}</h2>
        </div>
        <div className="infoMainContent">
          <div className="section-settings clear">
            <Grid container className="content">
              {/* 组织标题 */}
              <Grid item xs={12} className="org-header" style={{ marginTop: '20px' }}>
                <h4 style={{
                  margin: '16px 0 8px 0',
                  color: '#333',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  borderBottom: '2px solid #e0e0e0',
                  paddingBottom: '8px',
                  textAlign: 'left'
                }}>
                  {intl.formatMessage({ id: 'balance' })}
                </h4>
              </Grid>
              {
                // 使用正确的条件渲染和类型安全访问
                (accountInfo.accoutList && accountInfo.accoutList.length > 0 ? accountInfo.accoutList : []).map((item, index) => (
                  <React.Fragment key={`account-${index}`}>
                    <Grid item xs={3} className="info">
                      <span>{item.currency}</span>
                    </Grid>
                    <Grid item xs={9} className="info">
                      <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{item.unsettledAmt}</span>
                    </Grid>
                  </React.Fragment>
                ))
              }
              {/* <Grid item xs={3} className="info">
                <label>{intl.formatMessage({ id: 'balance' })}</label>
              </Grid>
              <Grid item xs={9} className="info">
                <span>{accountInfo.balanceAmt}{accountInfo.orgCurrency}</span>
              </Grid>
              <Grid item xs={3} className="info">
                <label>{intl.formatMessage({ id: 'unsettled' })}</label>
              </Grid>
              <Grid item xs={9} className="info">
                <span>{accountInfo.unsettledAmt}{accountInfo.orgCurrency}</span>
              </Grid> */}
              {/*<Grid item xs={3} className="info">*/}
              {/*    <label>{intl.formatMessage({id: 'minimumSettlementAmount'})}</label>*/}
              {/*</Grid>*/}
              {/*<Grid item xs={9} className="info">*/}
              {/*    <span>{accountInfo.lowestAmt}{accountInfo.orgCurrency}</span>*/}
              {/*</Grid>*/}


              {/* 组织列表分组展示 */}
              {accountInfo.orgList && accountInfo.orgList.length > 0 && accountInfo.orgList.map((org, index) => (
                <React.Fragment key={`org-${org.payOrg}-${index}`}>
                  {/* 组织标题 */}
                  <Grid item xs={12} className="org-header" style={{ marginTop: '20px' }}>
                    <h4 style={{
                      margin: '16px 0 8px 0',
                      color: '#333',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      borderBottom: '2px solid #e0e0e0',
                      paddingBottom: '8px',
                      textAlign: 'left'
                    }}>
                      {org.name}
                    </h4>
                  </Grid>

                  {/* 组织的起结金额 */}
                  <Grid item xs={3} className="info">
                    <label>{intl.formatMessage({ id: 'minimumSettlementAmount' }) || '起结金额'}:</label>
                  </Grid>
                  <Grid item xs={9} className="info">
                    <span style={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {org.withdrawAmt.toFixed(2)} {org.withdrawCurrency}
                    </span>
                  </Grid>

                  {/* 组织的结算币种 */}
                  <Grid item xs={3} className="info">
                    <label>{intl.formatMessage({ id: 'settlementCurrency' }) || '结算币种'}:</label>
                  </Grid>
                  <Grid item xs={9} className="info">
                    <span style={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {org.withdrawCurrency}
                    </span>
                  </Grid>

                  {/* 添加分隔线，除了最后一个组织 */}
                  {index < accountInfo.orgList.length - 1 && (
                    <Grid item xs={12} style={{ margin: '8px 0' }}>
                      <div style={{ borderTop: '1px solid #f0f0f0' }}></div>
                    </Grid>
                  )}
                </React.Fragment>
              ))}

              {/*<Grid item xs={12} className="info">*/}
              {/*    <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>{intl.formatMessage({id: 'cash'})}</Button>*/}
              {/*</Grid>*/}
            </Grid>
          </div>
        </div>
        <SimpleDialog open={this.state.open} onClose={this.handleClose} intl={intl} accountInfo={accountInfo} cashInfo={this.props.cashInfo} onOk={this.handleConfirm} onChange={this.handleChange}></SimpleDialog>
      </div>
    );
  }
}

export default injectIntl(connect((state: reducerStoreType) => {
  return {
    accountInfo: state.account.accountInfo,
    cashInfo: state.account.cashInfo
  }
})(AccountInfo))




